import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  descriptionWrapper: {
    display: 'flex',
  },
}))

export default useStyles
